import {EditFormDocument, EditFormInput} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useEditForm = () => {
  const [mutate] = useMutation(EditFormDocument);

  return (input: EditFormInput) => mutate({ variables: { input } });
}